import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="container mx-auto p-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold text-center mb-8">TERMS AND CONDITIONS</h1>
      
      <div className="prose max-w-none">
        <p className="mb-6">
          The Terms and Conditions contained herein shall apply to any person ("User") using the services of this PM WANI WiFi for making payments (data plan purchase related fees) through an online payment gateway service ("Service") offered by Payu, through this website or mobile application. Each User is therefore deemed to have read and accepted these Terms Of Services.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-4">A. Privacy Policy</h2>
        <p className="mb-4">
          Expertvision respects and protects the privacy of the individuals that access the information and use the services provided through them. Individually identifiable information about the User is not willfully disclosed to any third party without first receiving the User's permission, as covered in this Privacy Policy.
        </p>
        <p className="mb-4">
          This Privacy Policy describes Expertvision's treatment of personally identifiable information that Expertvision collects when User is on this website and mobile application does not collect any unique information about the User (such as User's name, email address, age, gender etc.) except when the User specifically and knowingly provide such information on the Website and mobile application.
        </p>
        <p className="mb-6">
          Please be aware, however, that Expertvision will release specific personal information about the User if required to do so in the following circumstances:
        </p>
        <ol className="list-decimal pl-6 mb-6 space-y-2">
          <li>In order to comply with any valid legal process such as a search warrant, statute, or court order, or</li>
          <li>If any of User's actions on Expertvision's website and mobile application violate the Terms of Service or any of Expertvision's guidelines for specific services, or</li>
          <li>To protect or defend Expertvision's legal rights or property, the Expertvision's site, or Expertvision's Users or</li>
          <li>To investigate, prevent, or take action regarding illegal activities, suspected fraud, situations involving potential threats to the security, integrity of Expertvision's website/mobile application/offerings.</li>
        </ol>

        <h2 className="text-xl font-bold mt-6 mb-4">B. General Terms and Conditions For Online-Payments</h2>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>Once a User has accepted these Terms and Conditions, he/she may register and avail the Services and products offered on the Expertvision's website/mobile application.</li>
          <li>The Expertvision rights, obligations, undertakings shall be subject to the laws in force in India, as well as any directives/procedures of Government of India.</li>
          <li>If any part of these Terms and Conditions are determined to be invalid or unenforceable pursuant to applicable law including, but not limited to, the warranty disclaimers and liability limitations set forth herein, then the invalid or unenforceable provision will be deemed superseded by a valid, enforceable provision that most closely matches the intent of the original provision.</li>
          <li>These Terms and Conditions constitute the entire agreement between the User and the Expertvision.</li>
          <li>The entries in the books of Expertvision and/or the Payment Service Providers kept in the ordinary course of business shall be binding on the User.</li>
        </ul>

        <h3 className="font-bold mt-4 mb-2">Cancellation & Refund:</h3>
        <h4 className="font-semibold mt-2">Cancellations Process</h4>
        <p className="mb-2">
          If your cancellation is at least 7 days in advance, you will receive a full refund. If your cancellation is less than 24 hours or after installation of PDO device in your location area, so cancellation will not be acceptable. For more detail please contact Expertvision admin or send email to us.
        </p>
        <h4 className="font-semibold mt-2">Refund Process</h4>
        <p className="mb-4">
          If eligible for returns/Cancellations, you can raise return/refund request by call, or you can also drop us an email mentioning which PDO device you would like to return. Our staff will provide packing instructions and guide you how to mail it to us.
        </p>
        <p className="mb-6">
          <strong>Note:</strong> Transaction fees levied on transactions will not be refunded/reversed.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-4">C. Limitation of Liability</h2>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>Expertvision has made this Service available to the User as a matter of convenience.</li>
          <li>Expertvision and/or the Payment Service Providers shall not be liable for any inaccuracy, error or delay in, or omission of any data, information or message.</li>
          <li>The User shall indemnify and hold harmless the Payment Service Provider(s) and Expertvision and their respective officers, directors, agents, and employees.</li>
          <li>The User agrees that Expertvision or any of its employees will not be held liable by the User for any loss or damages.</li>
          <li>Expertvision and the Payment Service Provider(s) assume no liability whatsoever for any monetary or other damage suffered by the User.</li>
        </ul>

        <h2 className="text-xl font-bold mt-6 mb-4">D. Miscellaneous Conditions</h2>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>Any waiver of any rights available to Expertvision under these Terms and Conditions shall not mean that those rights are automatically waived.</li>
          <li>The User agrees, understands and confirms that his/ her personal data including without limitation details relating to debit card/ credit card transmitted over the Internet may be susceptible to misuse.</li>
          <li>The User may be required to create his/her own User ID and Password in order to register and/ or use the Services.</li>
        </ul>

        <h2 className="text-xl font-bold mt-6 mb-4">E. Debit/Credit Card, Bank Account Details</h2>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>The User agrees that the debit/credit card details provided by him/ her must be correct and accurate.</li>
          <li>The User may pay his/her fees to Expertvision by using a debit/credit card or through online banking account.</li>
        </ul>

        <h2 className="text-xl font-bold mt-6 mb-4">F. Personal Information</h2>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>The User agrees that, to the extent required or permitted by law, Expertvision may also collect, use and disclose personal information.</li>
          <li>The User agrees that any communication sent by the User vide e-mail, shall imply release of information therein.</li>
          <li>The User acknowledges and agrees that his/her information will be managed in accordance with the laws for the time in force.</li>
        </ul>

        <h2 className="text-xl font-bold mt-6 mb-4">G. Payment Gateway Disclaimer</h2>
        <p className="mb-6">
          The Service is provided in order to facilitate access to PM WANI WiFi and pay data plan Fees online. Expertvision does not make any representation of any kind, express or implied, as to the operation of the Payment Gateway.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-4">Complaints</h2>
        <p className="mb-6">
          If you have any complaints about the Website/mobile application, we want to hear from you so we can improve our Service. Please email helpdesk.expertvision@gmail.com and we will consider your comments carefully.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-4">General Information</h2>
        <p className="mb-4">
          These Terms and Conditions constitute the entire agreement between you and Expertvision and govern your use of the Service. Our relationship with you is subject to Indian law and the exclusive jurisdiction of the Indian courts.
        </p>
        <p className="mb-6">
          All PM WANI data plans are inclusive of Goods and Services Tax (GST).
        </p>

        <h2 className="text-xl font-bold mt-6 mb-4">SHIPPING & DELIVERY POLICY</h2>
        <p className="mb-4">
          Thank you for visiting and shopping at Expertvision. Following are the terms and conditions that constitute our Shipping Policy.
        </p>
        <p className="mb-4">
          All items offered on Expertvision are made-to-order. This means that when you place your order, we process that item(s) just for you.
        </p>
        <p className="mb-2">
          <strong>Shipping carrier:</strong> DTDC, DELHIVERY, POST OFFICE.
        </p>
        <p className="mb-6">
          Orders are processed when the payment is accepted.
        </p>

        <h3 className="font-bold mt-4 mb-2">Domestic Shipping Policy</h3>
        <h4 className="font-semibold mt-2">SHIPPING & HANDLING</h4>
        <p className="mb-2">
          <strong>Delivery Time = Processing time + Shipping time</strong>
        </p>
        <p className="mb-4">
          We process orders on business days which are Monday through Friday, India Standard Time (IST), and exclude public holidays observed by the Courier Partner.
        </p>

        <h4 className="font-semibold mt-2">These are our estimates shipping time:</h4>
        <div className="mb-4">
          <p className="font-semibold">LOCATION</p>
          <p>*ESTIMATED SHIPPING TIME</p>
          <p>India: 7-14 Days</p>
          <p className="text-sm">*This doesn't include our 3-7 days processing time.</p>
        </div>

        <h4 className="font-semibold mt-2">SHIPPING FEE PER DEVICE</h4>
        <ul className="list-disc pl-6 mb-6">
          <li>Standard: ₹300.</li>
          <li>Express: ₹550.</li>
        </ul>

        <h4 className="font-semibold mt-2">ORDER TRACKING</h4>
        <p className="mb-4">
          You will receive a confirmation email with a tracking link so that you can follow your order all the way home! Please allow 3-7 days for the carrier to scan your package into their system.
        </p>

        <h4 className="font-semibold mt-2">INCORRECT ADDRESS</h4>
        <p className="mb-6">
          Make sure you provide the correct address at checkout because we are not responsible if your order gets delivered to the wrong address.
        </p>

        <h4 className="font-semibold mt-2">REFUNDS, RETURNS, AND EXCHANGES</h4>
        <p className="mb-6">
          We accept returns up to 2 days after delivery, if the item is unused and in its original condition, and we will refund the full order amount minus the shipping costs and other processing fee for the return.
        </p>

        <h4 className="font-semibold mt-2">Damages</h4>
        <p className="mb-6">
          Expertvision is not liable for any products damaged or lost during shipping. If you received your order damaged, please contact the shipment carrier to file a claim.
        </p>

        <h4 className="font-semibold mt-2">WHAT HAPPENS IF MY ORDER IS DELAYED</h4>
        <p className="mb-6">
          If delivery is delayed for any reason, we will let you know as soon as possible and will advise you of a revised estimated date for delivery.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;